import { defineStore } from "pinia";
import { GalaxyApi } from "@/api";
import { useKeyedCache } from "@/composables/keyedCache";
import { rethrowSimple } from "@/utils/simple-error";
export const useCollectionAttributesStore = defineStore("collectionAttributesStore", () => {
    async function fetchAttributes(params) {
        const { data, error } = await GalaxyApi().GET("/api/dataset_collections/{id}/attributes", {
            params: { path: params },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    }
    const { storedItems, getItemById, isLoadingItem, getItemLoadError } = useKeyedCache(fetchAttributes);
    return {
        storedAttributes: storedItems,
        getAttributes: getItemById,
        isLoadingAttributes: isLoadingItem,
        getItemLoadError: getItemLoadError,
    };
});
